<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="Cargando..."
        class="elevation-1"
        item-key="id"
        :footer-props="footerOptions"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <back-button v-if="module==='dealers'"></back-button>
            <v-toolbar-title v-html="title"></v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-on:input="debounceInput"
              label="Buscar"
              single-line
              hide-details />
            <v-divider class="mx-4" inset vertical></v-divider>
            <!-- <v-btn
              :color="themeColor"
              class="mb-2"
              @click="newItem()"
              v-if="module!=='dealers'"
            >Nuevo Registro</v-btn> -->
          </v-toolbar>
        </template>
        <template v-slot:item.active="{ item }">
          <v-switch v-model="item.active"></v-switch>
        </template>
        <template v-slot:item.action="{ item }">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }" v-if="module!=='dealers'">
              <v-icon :color="themeColor" @click="openModalShow(item)" dark v-on="on">mdi-layers-plus</v-icon>
            </template>
            <span>Generar Códigos</span>
          </v-tooltip> -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon :color="themeColor" @click="showStock(item)" dark v-on="on">mdi-credit-card</v-icon>
            </template>
            <span>Licencias</span>
          </v-tooltip>
        </template>
        <template v-slot:footer>
          <slot></slot>
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label>
          <br />
          <v-btn :color="themeColor" @click="reset">Limpiar búsqueda</v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogShow" max-width="400">
        <v-card>
          <v-card-title class="headline">Códigos de Licencia a generar</v-card-title>
          <v-card-text>
            <v-text-field v-model="codesAmount" label="Cantidad de códigos" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogShow = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click.prevent="createCodes()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import * as _ from 'underscore';
import BackButton from '~/components/BackButton';

export default {
  middleware: 'auth',
  props: {
    apiURL: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    module: { default: '' },
    bus: { default: null },
  },
  computed: {
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
  },
  components: {
    BackButton,
  },
  mounted() {
    if (this.bus) this.bus.$on('refreshTable', this.refreshTable);
  },
  data: () => ({
    codesAmount: 1,
    search: '',
    items: [],
    totalItems: 0,
    loading: false,
    footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
    dialogShow: false,
    options: {},
    message: '',
    type: '',
    apiURLGenerate: 'api/catalogs/services/generate',
    headers: [
      {
        text: 'Titulo',
        value: 'nombre',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Descripción',
        value: 'descripcion',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Duración (Meses)',
        value: 'tiempo',
        align: 'center',
        sortable: true,
      },
      {
        text: 'Cadencia (Meses)',
        value: 'cadencia',
        align: 'center',
        sortable: true,
      },
      {
        text: 'Folios',
        value: 'cantidad',
        align: 'center',
        sortable: true,
      },
      {
        text: 'Servicio',
        value: 'servicio',
        align: 'center',
        sortable: true,
      },
      {
        text: 'Total',
        value: 'stock',
        align: 'center',
        sortable: true,
      },
      {
        text: 'Disponibles',
        value: 'available',
        align: 'center',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
      },
    ],
  }),
  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    search: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },
  methods: {
    debounceInput: _.debounce(function d(e) {
      this.search = e;
    }, 500),
    refreshTable() {
      this.getDataFromApi().then((data) => {
        this.items = data.items;
        this.totalItems = data.total;
      });
    },
    getDataFromApi() {
      this.loading = true;

      return new Promise(async (resolve) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        const response = await this.getItems(
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
        ).then((response) => {
          const data = response.data.items;
          const { total } = response.data;
          return { data, total } || [];
        });
        const items = response.data;
        const { total } = response;

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total,
          });
        }, 1000);
      });
    },
    getItems(page, itemsPerPage, sortBy, sortDesc) {
      const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}&search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}`;
      const promise = window.axios.get(url).then();
      return promise;
    },
    newItem() {
      this.$router.push({ path: `${this.$router.currentRoute.path}/agregar` });
    },
    showStock(item) {
      this.$router.push({
        path: `${this.$router.currentRoute.path}/${item.id}`,
        params: { id: item.id },
      });
    },
    reset() {
      this.search = '';
    },
    createCodes() {
      const url = `${this.apiURLGenerate}`;
      window.axios
        .post(url, {
          licence_id: this.item.id,
          amount: this.codesAmount,
        })
        .then((response) => {
          this.message = response.data.message;
          this.type = response.data.type;
          this.dialogShow = false;
          this.refreshTable();
        });
    },
    openModalShow(item) {
      this.dialogShow = true;
      this.item = item;
    },
  },
};
</script>
